
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.279 5.747a3.032 3.032 0 00-2.656 2.515 22.74 22.74 0 000 7.476 3.032 3.032 0 002.656 2.515l.53.06c4.115.456 8.267.456 12.382 0l.53-.06a3.032 3.032 0 002.656-2.515 22.74 22.74 0 000-7.476 3.032 3.032 0 00-2.656-2.515l-.53-.06a56.061 56.061 0 00-12.382 0l-.53.06zm9.473 7.085a1 1 0 000-1.664l-3.197-2.132A1 1 0 0010 9.868v4.264a1 1 0 001.555.832l3.197-2.132z"}})])
          )
        }
      }
    